import { Link } from 'react-router-dom';
import { MapPin, Phone, Clock, Truck, ShieldCheck, Wrench, Home, Accessibility, BedDouble, PersonStanding, Bike, ShowerHead, Armchair } from 'lucide-react';

const LANGS = ['pt', 'en', 'es', 'fr', 'it', 'de'];

const categories = [
  {
    slug: 'cadeiras-de-rodas', icon: Accessibility,
    name: { pt: 'Cadeiras de Rodas', en: 'Wheelchairs', es: 'Sillas de Ruedas', fr: 'Fauteuils Roulants', it: 'Carrozzelle', de: 'Rollstühle' },
    desc: {
      pt: 'Manuais e elétricas, para adulto e pediátricas.',
      en: 'Manual and electric, adult and pediatric.',
      es: 'Manuales y eléctricas, para adultos y pediátricas.',
      fr: 'Manuels et électriques, pour adultes et pédiatriques.',
      it: 'Manuali ed elettriche, per adulti e pediatriche.',
      de: 'Manuelle und elektrische, für Erwachsene und Kinder.',
    },
  },
  {
    slug: 'camas-articuladas', icon: BedDouble,
    name: { pt: 'Camas Articuladas', en: 'Hospital Beds', es: 'Camas Articuladas', fr: 'Lits Articulés', it: 'Letti Articolati', de: 'Krankenbetten' },
    desc: {
      pt: 'Elétricas hospitalares com entrega e montagem.',
      en: 'Electric hospital beds with delivery and assembly.',
      es: 'Camas eléctricas hospitalarias con entrega y montaje.',
      fr: 'Lits électriques hospitaliers avec livraison et montage.',
      it: 'Letto elettrici ospedalieri con consegna e montaggio.',
      de: 'Elektrische Krankenhausbetten mit Lieferung und Montage.',
    },
  },
  {
    slug: 'andarilhos', icon: PersonStanding,
    name: { pt: 'Andarilhos', en: 'Walkers', es: 'Andadores', fr: 'Déambulateurs', it: 'Deambulatori', de: 'Rollatoren' },
    desc: {
      pt: 'Andarilhos de 2 e 4 rodas, bengalas e muletas.',
      en: '2 and 4-wheel walkers, canes and crutches.',
      es: 'Andadores de 2 y 4 ruedas, bastones y muletas.',
      fr: 'Déambulateurs à 2 et 4 roues, cannes et béquilles.',
      it: 'Deambulatori a 2 e 4 ruote, bastoni e stampelle.',
      de: '2- und 4-Rad-Rollatoren, Gehstöcke und Krücken.',
    },
  },
  {
    slug: 'scooters', icon: Bike,
    name: { pt: 'Scooters de Mobilidade', en: 'Mobility Scooters', es: 'Scooters de Movilidad', fr: 'Scooters de Mobilité', it: 'Scooter per Mobilità', de: 'Mobilitätsscooter' },
    desc: {
      pt: 'Scooters elétricos para mobilidade reduzida e turismo.',
      en: 'Electric scooters for reduced mobility and tourism.',
      es: 'Scooters eléctricos para movilidad reducida y turismo.',
      fr: 'Scooters électriques pour mobilité réduite et tourisme.',
      it: 'Scooter elettrici per mobilità ridotta e turismo.',
      de: 'Elektrische Scooter für eingeschränkte Mobilität und Tourismus.',
    },
  },
  {
    slug: 'cadeiras-de-banho', icon: ShowerHead,
    name: { pt: 'Cadeiras de Banho', en: 'Shower Chairs', es: 'Sillas de Ducha', fr: 'Sièges de Douche', it: 'Sedie da Doccia', de: 'Duschstühle' },
    desc: {
      pt: 'Higiene e segurança na casa de banho.',
      en: 'Bathroom hygiene and safety.',
      es: 'Higiene y seguridad en el baño.',
      fr: 'Hygiène et sécurité dans la salle de bain.',
      it: 'Igiene e sicurezza in bagno.',
      de: 'Hygiene und Sicherheit im Badezimmer.',
    },
  },
  {
    slug: 'poltronas', icon: Armchair,
    name: { pt: 'Poltronas', en: 'Lift Chairs', es: 'Sillones Elevadores', fr: 'Fauteuils Élévateurs', it: 'Poltrone Elevatrici', de: 'Liftsessel' },
    desc: {
      pt: 'Poltronas reclináveis e elevatórias relax.',
      en: 'Reclining and lift chairs.',
      es: 'Sillones reclinables y elevadores relax.',
      fr: 'Fauteuils inclinables et élérateurs relax.',
      it: 'Poltrone reclinabili ed elevatrici relax.',
      de: 'Rücklehnbare und Liftsessel zum Entspannen.',
    },
  },
];

const strings = {
  pt: {
    introTitle: 'Venda e Aluguer de Material Ortopédico em Portugal',
    introP1: 'A Gestos Ágeis é uma loja de ortopedia em Lisboa especializada na venda e aluguer de material ortopédico e ajudas técnicas. Cadeiras de rodas, camas articuladas, andarilhos, scooters de mobilidade, poltronas elevatórias e equipamento de higiene e segurança, com entrega ao domicílio em todo Portugal Continental — Lisboa, Porto, Braga, Coimbra, Aveiro, Cascais, Setúbal, Faro e Évora.',
    introP2: 'Alugue por dias, semanas ou meses, com entrega e recolha incluídas, contrato digital e pagamento online (MB Way, Multibanco ou transferência). Para quem prefere comprar, dispomos de equipamento novo das melhores marcas nas nossas lojas de Benfica e Junqueira. Atendimento técnico especializado e apoio 24 horas via WhatsApp e telefone.',
    features: [
      'Entrega 24h em Portugal',
      'Equipamento higienizado e certificado',
      'Montagem e assistência técnica',
      'Lojas físicas em Benfica e Junqueira, Lisboa',
    ],
    catTitle: 'Material Ortopédico para Aluguer',
    catSubtitle: 'Escolha a categoria e reserve online com entrega ao domicílio',
    storesTitle: 'Lojas de Ortopedia em Benfica e Junqueira, Lisboa',
    address: 'Morada',
    hours: 'Horário',
    hoursBenfica: '2ª a 6ª: 9h30–13h e 14h–18h30 | Sábado: 9h–13h',
    hoursJunqueira: '2ª a 6ª: 10h–13h e 14h–18h30',
    footerNote: 'Gestos Ágeis Unipessoal Lda — lojas de ortopedia e ajudas técnicas em Lisboa, com serviço de aluguer e venda para todo Portugal.',
  },
  en: {
    introTitle: 'Orthopedic Equipment Sales & Rental in Portugal',
    introP1: 'Gestos Ágeis is an orthopedic store in Lisbon specializing in the sale and rental of orthopedic equipment and daily living aids. Wheelchairs, hospital beds, walkers, mobility scooters, lift chairs and bathroom safety equipment, with home delivery across mainland Portugal — Lisbon, Porto, Braga, Coimbra, Aveiro, Cascais, Setúbal, Faro and Évora.',
    introP2: 'Rent by the day, week or month, with delivery and pickup included, digital contract and online payment (MB Way, Multibanco or bank transfer). If you prefer to buy, we stock new equipment from the best brands in our Benfica and Junqueira stores. Specialized technical support and 24-hour assistance via WhatsApp and phone.',
    features: [
      '24h delivery in Portugal',
      'Sanitized & certified equipment',
      'Assembly & technical support',
      'Physical stores in Benfica and Junqueira, Lisbon',
    ],
    catTitle: 'Orthopedic Equipment for Rental',
    catSubtitle: 'Choose a category and book online with home delivery',
    storesTitle: 'Orthopedic Stores in Benfica and Junqueira, Lisbon',
    address: 'Address',
    hours: 'Hours',
    hoursBenfica: 'Mon–Fri: 9:30am–1pm and 2pm–6:30pm | Sat: 9am–1pm',
    hoursJunqueira: 'Mon–Fri: 10am–1pm and 2pm–6:30pm',
    footerNote: 'Gestos Ágeis Unipessoal Lda — orthopedic stores and daily living aids in Lisbon, with rental and sales service across Portugal.',
  },
  es: {
    introTitle: 'Venta y Alquiler de Material Ortopédico en Portugal',
    introP1: 'Gestos Ágeis es una tienda de ortopedia en Lisboa especializada en la venta y alquiler de material ortopédico y ayudas técnicas. Sillas de ruedas, camas articuladas, andadores, scooters de movilidad, sillones elevadores y equipamiento de higiene y seguridad, con entrega a domicilio en todo Portugal Continental — Lisboa, Porto, Braga, Coímbra, Aveiro, Cascais, Setúbal, Faro y Évora.',
    introP2: 'Alquile por días, semanas o meses, con entrega y recogida incluidas, contrato digital y pago online (MB Way, Multibanco o transferencia). Para quien prefiere comprar, disponemos de equipo nuevo de las mejores marcas en nuestras tiendas de Benfica y Junqueira. Atención técnica especializada y apoyo 24 horas vía WhatsApp y teléfono.',
    features: [
      'Entrega 24h en Portugal',
      'Equipo higienizado y certificado',
      'Montaje y asistencia técnica',
      'Tiendas físicas en Benfica y Junqueira, Lisboa',
    ],
    catTitle: 'Material Ortopédico para Alquiler',
    catSubtitle: 'Elija una categoría y reserve online con entrega a domicilio',
    storesTitle: 'Tiendas de Ortopedia en Benfica y Junqueira, Lisboa',
    address: 'Dirección',
    hours: 'Horario',
    hoursBenfica: 'Lun–Vie: 9:30–13h y 14–18:30h | Sáb: 9–13h',
    hoursJunqueira: 'Lun–Vie: 10–13h y 14–18:30h',
    footerNote: 'Gestos Ágeis Unipessoal Lda — tiendas de ortopedia y ayudas técnicas en Lisboa, con servicio de alquiler y venta para todo Portugal.',
  },
  fr: {
    introTitle: "Vente et Location de Matériel Orthopédique au Portugal",
    introP1: "Gestos Ágeis est un magasin d'orthopédie à Lisbonne spécialisé dans la vente et la location de matériel orthopédique et d'aides techniques. Fauteuils roulants, lits articulés, déambulateurs, scooters de mobilité, fauteuils élévateurs et matériel d'hygiène et de sécurité, avec livraison à domicile dans tout le Portugal continental — Lisbonne, Porto, Braga, Coimbra, Aveiro, Cascais, Setúbal, Faro et Évora.",
    introP2: "Louez à la journée, à la semaine ou au mois, avec livraison et retrait inclus, contrat numérique et paiement en ligne (MB Way, Multibanco ou virement). Pour ceux qui préfèrent acheter, nous proposons du matériel neuf des meilleures marques dans nos magasins de Benfica et Junqueira. Assistance technique spécialisée et soutien 24h/24 via WhatsApp et téléphone.",
    features: [
      'Livraison 24h au Portugal',
      'Matériel désinfecté et certifié',
      'Montage et assistance technique',
      'Magasins physiques à Benfica et Junqueira, Lisbonne',
    ],
    catTitle: 'Matériel Orthopédique à Louer',
    catSubtitle: 'Choisissez une catégorie et réservez en ligne avec livraison à domicile',
    storesTitle: 'Magasins d’Orthopédie à Benfica et Junqueira, Lisbonne',
    address: 'Adresse',
    hours: 'Horaires',
    hoursBenfica: 'Lun–Ven : 9h30–13h et 14h–18h30 | Sam : 9h–13h',
    hoursJunqueira: 'Lun–Ven : 10h–13h et 14h–18h30',
    footerNote: "Gestos Ágeis Unipessoal Lda — magasins d'orthopédie et aides techniques à Lisbonne, avec service de location et vente pour tout le Portugal.",
  },
  it: {
    introTitle: 'Vendita e Noleggio di Materiale Ortopedico in Portogallo',
    introP1: 'Gestos Ágeis è un negozio di ortopedia a Lisbona specializzato nella vendita e nel noleggio di materiale ortopedico e ausili. Carrozzelle, letti articolati, deambulatori, scooter per mobilità, poltrone elevatrici e attrezzatura per igiene e sicurezza, con consegna a domicilio in tutto il Portogallo continentale — Lisbona, Porto, Braga, Coimbra, Aveiro, Cascais, Setúbal, Faro e Évora.',
    introP2: 'Noleggia a giorni, settimane o mesi, con consegna e ritiro inclusi, contratto digitale e pagamento online (MB Way, Multibanco o bonifico). Per chi preferisce acquistare, disponiamo di attrezzatura nuova delle migliori marche nei nostri negozi di Benfica e Junqueira. Assistenza tecnica specializzata e supporto 24 ore via WhatsApp e telefono.',
    features: [
      'Consegna 24h in Portogallo',
      'Attrezzatura sanificata e certificata',
      'Montaggio e assistenza tecnica',
      'Negozi fisici a Benfica e Junqueira, Lisbona',
    ],
    catTitle: 'Materiale Ortopedico per Noleggio',
    catSubtitle: 'Scegli una categoria e prenota online con consegna a domicilio',
    storesTitle: 'Negozi di Ortopedia a Benfica e Junqueira, Lisbona',
    address: 'Indirizzo',
    hours: 'Orari',
    hoursBenfica: 'Lun–Ven: 9:30–13 e 14–18:30 | Sab: 9–13',
    hoursJunqueira: 'Lun–Ven: 10–13 e 14–18:30',
    footerNote: 'Gestos Ágeis Unipessoal Lda — negozi di ortopedia e ausili a Lisbona, con servizio di noleggio e vendita per tutto il Portogallo.',
  },
  de: {
    introTitle: 'Verkauf und Vermietung von orthopädischem Material in Portugal',
    introP1: 'Gestos Ágeis ist ein Orthopädiegeschäft in Lissabon, spezialisiert auf Verkauf und Vermietung von orthopädischem Material und Hilfsmitteln. Rollstühle, Krankenbetten, Rollatoren, Mobilitätsscooter, Liftsessel und Ausrüstung für Hygiene und Sicherheit, mit Lieferservice im gesamten portugiesischen Festland — Lissabon, Porto, Braga, Coimbra, Aveiro, Cascais, Setúbal, Faro und Évora.',
    introP2: 'Mieten Sie tageweise, wochen- oder monatsweise, inklusive Lieferung und Abholung, digitalem Vertrag und Online-Zahlung (MB Way, Multibanco oder Überweisung). Wer lieber kaufen möchte, findet in unseren Geschäften in Benfica und Junqueira Neuware der besten Marken. Fachkundiger technischer Support und 24-Stunden-Hilfe via WhatsApp und Telefon.',
    features: [
      '24h-Lieferung in Portugal',
      'Desinfizierte & zertifizierte Geräte',
      'Montage und technischer Support',
      'Filialen in Benfica und Junqueira, Lissabon',
    ],
    catTitle: 'Orthopädisches Material zur Miete',
    catSubtitle: 'Wählen Sie eine Kategorie und buchen Sie online mit Lieferservice',
    storesTitle: 'Orthopädiegeschäfte in Benfica und Junqueira, Lissabon',
    address: 'Adresse',
    hours: 'Öffnungszeiten',
    hoursBenfica: 'Mo–Fr: 9:30–13 und 14–18:30 | Sa: 9–13',
    hoursJunqueira: 'Mo–Fr: 10–13 und 14–18:30',
    footerNote: 'Gestos Ágeis Unipessoal Lda — Orthopädiegeschäfte und Hilfsmittel in Lissabon, mit Miet- und Verkaufsservice für ganz Portugal.',
  },
};

const featureIcons = [Truck, ShieldCheck, Wrench, Home];

export default function GestosAgeisContent({ language = 'pt' }) {
  const lang = LANGS.includes(language) ? language : 'pt';
  const s = strings[lang];

  return (
    <>
      {/* Intro / authority content (GEO-friendly) */}
      <section className="py-8 px-4 bg-white">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3">
            {s.introTitle}
          </h2>
          <p className="text-gray-700 text-sm sm:text-base leading-relaxed mb-3">
            {s.introP1}
          </p>
          <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
            {s.introP2}
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-6">
            {s.features.map((label, i) => {
              const Icon = featureIcons[i];
              return (
                <div key={i} className="flex flex-col items-center text-center gap-1.5 p-2">
                  <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-blue-600" />
                  </div>
                  <p className="text-xs font-medium text-gray-700 leading-tight">{label}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Category grid (internal links to rental category pages) */}
      <section className="py-8 px-4 bg-gray-50">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1 text-center">
            {s.catTitle}
          </h2>
          <p className="text-gray-500 text-sm text-center mb-6">
            {s.catSubtitle}
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
            {categories.map((c) => (
              <Link
                key={c.slug}
                to={`/aluguer/categoria/${c.slug}`}
                className="group bg-white rounded-xl border border-gray-200 p-4 hover:border-[#0e6b4f] hover:shadow-md transition-all flex flex-col items-center text-center">
                <span className="w-11 h-11 rounded-xl bg-[#0e6b4f]/10 flex items-center justify-center mb-2">
                  <c.icon className="w-6 h-6 text-[#0e6b4f]" />
                </span>
                <h3 className="font-bold text-gray-900 text-sm mb-1 group-hover:text-[#0e6b4f] transition-colors">
                  {c.name[lang]}
                </h3>
                <p className="text-xs text-gray-500 leading-tight">{c.desc[lang]}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Physical stores (Local SEO) */}
      <section className="py-8 px-4 bg-white">
        <div className="max-w-3xl mx-auto bg-gradient-to-br from-blue-50 to-green-50 rounded-2xl p-6 border border-blue-100">
          <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
            <MapPin className="w-5 h-5 text-blue-600" />
            {s.storesTitle}
          </h2>
          <div className="grid sm:grid-cols-2 gap-4 text-sm">
            <div className="bg-white/60 rounded-xl p-4 border border-blue-100">
              <p className="font-bold text-gray-900 mb-2">Benfica</p>
              <div className="flex items-start gap-2 mb-2">
                <MapPin className="w-4 h-4 text-gray-400 mt-0.5 shrink-0" />
                <div>
                  <p className="font-semibold text-gray-900">{s.address}</p>
                  <p className="text-gray-600">Estrada de Benfica 739A, 1500-089 Lisboa</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Clock className="w-4 h-4 text-gray-400 mt-0.5 shrink-0" />
                <div>
                  <p className="font-semibold text-gray-900">{s.hours}</p>
                  <p className="text-gray-600">{s.hoursBenfica}</p>
                </div>
              </div>
            </div>
            <div className="bg-white/60 rounded-xl p-4 border border-blue-100">
              <p className="font-bold text-gray-900 mb-2">Junqueira</p>
              <div className="flex items-start gap-2 mb-2">
                <MapPin className="w-4 h-4 text-gray-400 mt-0.5 shrink-0" />
                <div>
                  <p className="font-semibold text-gray-900">{s.address}</p>
                  <p className="text-gray-600">Rua da Junqueira 61F, Lisboa</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Clock className="w-4 h-4 text-gray-400 mt-0.5 shrink-0" />
                <div>
                  <p className="font-semibold text-gray-900">{s.hours}</p>
                  <p className="text-gray-600">{s.hoursJunqueira}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 mt-4 text-sm">
            <div className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-gray-400 shrink-0" />
              <a href="tel:+351216035281" className="text-blue-600 hover:underline">+351 216 035 281</a>
            </div>
            <div className="flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-gray-400 shrink-0" />
              <a href="mailto:geral@gestosageis.com" className="text-blue-600 hover:underline">geral@gestosageis.com</a>
            </div>
          </div>
          <p className="text-xs text-gray-500 mt-4">
            {s.footerNote}
          </p>
        </div>
      </section>
    </>
  );
}